import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
  const user = localStorage.getItem("user");
  const token = localStorage.getItem("token");
  
  let parsedUser = null;
  let isVerified = false;
  
  if (user) {
    try {
      parsedUser = JSON.parse(user);
      isVerified = !!(parsedUser?.email_verified_at || parsedUser?.phone_number_verified_at);
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      // Clear invalid user data
      localStorage.removeItem("user");
    }
  }
  
  return {
    isAuthenticated: !!token,
    isVerified,
    user: parsedUser,
    token: token || null,
  };
};
const initialState = loadInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = true;
      if (
        action.payload?.email_verified_at ||
        action.payload?.phone_number_verified_at
      ) {
        state.isVerified = true;
      } else {
        state.isVerified = false;
      }
      localStorage.setItem("user", JSON.stringify(action.payload));
      if (action.payload?.token) {
        localStorage.setItem("token", action.payload.token);
      }
    },
    setNewUser(state, action) {
      // For newly registered users, explicitly set verification to false
      state.user = action.payload;
      state.isAuthenticated = true;
      state.isVerified = false;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    setToken(state, action) {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem("token", action.payload);
      }
      state.isAuthenticated = !!action.payload;
      if (action.payload && !state.user) {
        const user = localStorage.getItem("user");
        if (user) {
          try {
            state.user = JSON.parse(user);
            state.isVerified = !!(state.user?.email_verified_at || state.user?.phone_number_verified_at);
          } catch (error) {
            console.error("Error parsing user from localStorage:", error);
          }
        }
      }
    },
    clearAuth(state) {
      state.isAuthenticated = false;
      state.isVerified = false;
      state.user = null;
      state.token = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
  },
});

export const { setUser, setNewUser, setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;
